import { format } from "date-fns";
const displayDate = (date, dateFormat = "DD.MM.YYYY") => format(date, dateFormat);
const displayTime = (date, timeFormat = "HH:mm:ss") => format(date, timeFormat);
export { displayDate, displayTime };
